document.addEventListener('DOMContentLoaded', () => {

  const questions = document.querySelectorAll('.faq-question');

  for (var i = 0; i < questions.length; i++) {
    questions[i].addEventListener('click', e => {
      const id = e.target.closest('.faq-question')?.dataset.answer;

      const selectedAnswer = document.getElementById(id);
      const isHidden = selectedAnswer.classList.contains('hidden');

      if (isHidden) {
        selectedAnswer?.classList.remove('hidden');
        e.target.closest('.faq-question').classList.add('active')
      } else {
        selectedAnswer?.classList.add('hidden');
        e.target.closest('.faq-question').classList.remove('active')
      }
    });
  }
});